import createImmutableSelector from 'lib/immutable/selector'
import { IElCole } from './../models'

// TODO: import Store type and add reducer type in Store interface
const getElCole = (state: any): IElCole => state.get('elColeReducer')

export const elColeSelector = createImmutableSelector(getElCole, (elCole) => elCole)
